import { useState } from "react";
import { useFormContext } from "react-hook-form";

/**
 * ProcessHeader component displays and allows editing of the process name and description.
 * Uses react-hook-form for inline editing capabilities.
 *
 * @returns Process header UI with editable fields
 */
export default function ProcessHeader() {
  const { register, watch } = useFormContext();
  const [isEditingName, setIsEditingName] = useState(false);
  const [isEditingDescription, setIsEditingDescription] = useState(false);

  const processName = watch("processName");
  const description = watch("description");

  return (
    <div className="space-y-2">
      {/* Editable Process Name */}
      {isEditingName ? (
        <input
          {...register("processName")}
          autoFocus
          onBlur={() => setIsEditingName(false)}
          onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === "Escape") {
              setIsEditingName(false);
            }
          }}
          className="text-lg font-semibold bg-[#f4f4f5] border border-[#e4e4e7] rounded px-2 py-1 w-full focus:outline-none focus:border-[#d4d4d8]"
        />
      ) : (
        <h2
          className="text-lg font-semibold cursor-pointer hover:bg-[#f4f4f5] rounded px-2 py-1 -mx-2 transition-colors"
          onClick={() => setIsEditingName(true)}
          title="Click to edit"
        >
          {processName || "Untitled Process"}
        </h2>
      )}

      {/* Editable Description */}
      {isEditingDescription ? (
        <textarea
          {...register("description")}
          autoFocus
          onBlur={() => setIsEditingDescription(false)}
          onKeyDown={(e) => {
            if (e.key === "Escape") {
              setIsEditingDescription(false);
            }
          }}
          className="text-sm text-[#71717a] leading-relaxed bg-[#f4f4f5] border border-[#e4e4e7] rounded px-2 py-1 w-full focus:outline-none focus:border-[#d4d4d8] min-h-[60px] resize-y"
          rows={3}
        />
      ) : (
        <p
          className="text-sm text-[#71717a] leading-relaxed cursor-pointer hover:bg-[#f4f4f5] rounded px-2 py-1 -mx-2 transition-colors"
          onClick={() => setIsEditingDescription(true)}
          title="Click to edit"
        >
          {description || "Click to add a description..."}
        </p>
      )}
    </div>
  );
}
